import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Lock,
  Visibility,
  VisibilityOff,
  Check,
  Close,
} from "@mui/icons-material";
import InputText from "../text/input";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const StrengthErrors = {
  SENHA_CURTA: "Minímo de 8 caracteres",
  MAIUSCULA_MINUSCULA: "Uma letra maíscula e minúscula",
  UM_DIGITO: "Um número",
  UM_CARACTER_ESPECIAL: "Um caracter especial",
};

const allStrengthErrors = [
  StrengthErrors.SENHA_CURTA,
  StrengthErrors.MAIUSCULA_MINUSCULA,
  StrengthErrors.UM_DIGITO,
  StrengthErrors.UM_CARACTER_ESPECIAL,
];

function getPasswordErrors(password) {
  const errors = [];

  if (!password || password.length < 8) {
    errors.push(StrengthErrors.SENHA_CURTA);
  }

  if (password && !/(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
    errors.push(StrengthErrors.MAIUSCULA_MINUSCULA);
  }

  if (password && !/(?=.*[0-9])/.test(password)) {
    errors.push(StrengthErrors.UM_DIGITO);
  }

  if (password && !/[!@#$%^&*)(+=._-]/.test(password)) {
    errors.push(StrengthErrors.UM_CARACTER_ESPECIAL);
  }

  return errors;
}

function StatusIcon({ ok }) {
  return ok ? (
    <Check style={{ marginRight: "0.1rem", color: "green" }} fontSize="small" />
  ) : (
    <Close style={{ marginRight: "0.1rem", color: "red" }} fontSize="small" />
  );
}

export default function PasswordField({
  label = "",
  value,
  onChange,
  strengthInfo = false,
  white = false,
  required = false,
  confirmPassword,
  setPasswordIsOk = () => null,
}) {
  const [vizible, setVizible] = useState(false);
  const hasValue = value && value.length;
  const errors = strengthInfo
    ? hasValue
      ? getPasswordErrors(value)
      : allStrengthErrors
    : [];
  const shouldShowConfirm = typeof confirmPassword !== "undefined";
  const passwordsMatch =
    shouldShowConfirm && value === confirmPassword && hasValue;

  const passwordToValidate = strengthInfo
    ? value
    : shouldShowConfirm
    ? confirmPassword
    : value;
  const validationErrors = getPasswordErrors(passwordToValidate || "");

  const checklistTextColor = white
    ? themeColorsDesingSystem.text.secondary
    : themeColorsDesingSystem.text.primary;

  useEffect(() => {
    let isOk = false;

    if (validationErrors.length > 0) {
      isOk = false;
    } else if (shouldShowConfirm) {
      isOk = !!hasValue && passwordsMatch;
    } else {
      isOk = !!hasValue;
    }

    setPasswordIsOk(isOk);
  }, [
    validationErrors.length,
    shouldShowConfirm,
    passwordsMatch,
    hasValue,
    setPasswordIsOk,
  ]);

  return (
    <div>
      <InputText
        type={vizible ? "text" : "password"}
        label={label}
        value={value}
        onChange={onChange}
        placeholder="Senha"
        endAdornment={
          vizible ? (
            <VisibilityOff
              onClick={() => setVizible(!vizible)}
              style={{ cursor: "pointer" }}
            />
          ) : (
            <Visibility
              onClick={() => setVizible(!vizible)}
              style={{ cursor: "pointer" }}
            />
          )
        }
        errorMessage=""
        startAdornment={<Lock />}
        white={white}
        required={required}
      />
      {strengthInfo &&
        allStrengthErrors.map((error, index) => (
          <div key={index}>
            <StatusIcon ok={!errors.includes(error)} />
            <Typography variant="caption" sx={{ color: checklistTextColor }}>
              {error}
            </Typography>
          </div>
        ))}
      {shouldShowConfirm && (
        <div style={{ marginTop: "0.5rem" }}>
          <StatusIcon ok={passwordsMatch} />
          <Typography variant="caption" sx={{ color: checklistTextColor }}>
            {passwordsMatch ? "Senhas conferem" : "As senhas devem ser iguais"}
          </Typography>
        </div>
      )}
    </div>
  );
}
